import { render, staticRenderFns } from "./FatChartAllocations.vue?vue&type=template&id=7ebb5efe&scoped=true"
import script from "./FatChartAllocations.vue?vue&type=script&lang=js"
export * from "./FatChartAllocations.vue?vue&type=script&lang=js"
import style0 from "./FatChartAllocations.vue?vue&type=style&index=0&id=7ebb5efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebb5efe",
  null
  
)

export default component.exports